const padDate = (value: number): string => `${value < 10 ? '0' : ''}${value}`;

const dateToString = (date: Date) =>
  `${date.getFullYear()}-${padDate(date.getMonth() + 1)}-${padDate(
    date.getDate(),
  )}`;

export default dateToString;
